import api from '../client';

export const listEffectiveTime = (tenantId, year, month) =>
  api.get(`/tdabc/effective-time/${tenantId}`, {
    params: { year, ...(month != null ? { month } : {}) },
  });

export const upsertEffectiveTime = (tenantId, personId, year, month, data) =>
  api.put(`/tdabc/effective-time/${tenantId}/${personId}/${year}/${month}`, data);

export const bulkUpsertEffectiveTime = (tenantId, payload) =>
  api.post(`/tdabc/effective-time/${tenantId}/bulk`, payload);

export const deleteEffectiveTime = (tenantId, entryId) =>
  api.delete(`/tdabc/effective-time/${tenantId}/${entryId}`);

export const getEffectiveTimeRecap = (tenantId, year, month_to) =>
  api.get(`/tdabc/effective-time/${tenantId}/recap`, {
    params: { year, ...(month_to != null ? { month_to } : {}) },
  });

export const getEffectiveTimeComparative = (tenantId, year) =>
  api.get(`/tdabc/effective-time/${tenantId}/comparative`, { params: { year } });

// Excel export URL (used with fetch→blob pattern to preserve CRA proxy auth)
export const effectiveTimeExportUrl    = (tenantId, year) =>
  `/api/tdabc/effective-time/${tenantId}/export?year=${year}`;

// Excel template URL (5 sheets, people pre-filled, re-importable)
export const effectiveTimeTemplateUrl  = (tenantId, year) =>
  `/api/tdabc/effective-time/${tenantId}/template?year=${year}`;

// Excel import
export const importEffectiveTimeExcel = (tenantId, year, file) => {
  const form = new FormData();
  form.append('file', file);
  return api.post(
    `/tdabc/effective-time/${tenantId}/import-excel?year=${year}`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
};

// Import « matrice » client (1 feuille = 1 catégorie, noms en lignes).
// Aperçu de prudence : onglets, année détectée, personnes reconnues / non.
export const previewImportMatrix = (tenantId, file, { sheet, year } = {}) => {
  const form = new FormData();
  form.append('file', file);
  if (sheet != null) form.append('sheet', sheet);
  if (year != null) form.append('year', year);
  return api.post(`/tdabc/effective-time/${tenantId}/import-matrix/preview`, form,
    { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Import en fusion d'une catégorie + mémorise les alias (mapping manuel).
export const importMatrix = (tenantId, file, { sheet, year, category, manualMap } = {}) => {
  const form = new FormData();
  form.append('file', file);
  form.append('sheet', sheet);
  form.append('year', year);
  form.append('category', category);
  if (manualMap && Object.keys(manualMap).length) {
    form.append('manual_map', JSON.stringify(manualMap));
  }
  return api.post(`/tdabc/effective-time/${tenantId}/import-matrix`, form,
    { headers: { 'Content-Type': 'multipart/form-data' } });
};

// Import par copier-coller (texte collé depuis Excel — colonnes = tabulations).
export const previewImportPaste = (tenantId, text, year) => {
  const form = new FormData();
  form.append('text', text);
  if (year != null) form.append('year', year);
  return api.post(`/tdabc/effective-time/${tenantId}/import-paste/preview`, form,
    { headers: { 'Content-Type': 'multipart/form-data' } });
};

export const importPaste = (tenantId, { text, year, category, manualMap } = {}) => {
  const form = new FormData();
  form.append('text', text);
  form.append('year', year);
  form.append('category', category);
  if (manualMap && Object.keys(manualMap).length) {
    form.append('manual_map', JSON.stringify(manualMap));
  }
  return api.post(`/tdabc/effective-time/${tenantId}/import-paste`, form,
    { headers: { 'Content-Type': 'multipart/form-data' } });
};
